<div *ngFor="let filterGroup of filterSet" class="active-filter" [class.read-only]="filterGroup.readOnly">
	<ng-container *ngFor="let filter of filterGroup.filters">
		<bb-horizontal-filter [filter]="filter" (onRemove)="filterRemoved($event)"></bb-horizontal-filter>
	</ng-container>
</div>
